import { render } from "./PhotoEditorModal.vue?vue&type=template&id=d5cdb858"
import script from "./PhotoEditorModal.vue?vue&type=script&lang=js"
export * from "./PhotoEditorModal.vue?vue&type=script&lang=js"

import "./PhotoEditorModal.vue?vue&type=style&index=0&id=d5cdb858&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__